import React from 'react';
import { MdAddAPhoto } from 'react-icons/md';
import './SnapShotButton.css';

var SnapShotButton = function SnapShotButton(_ref) {
  var handleSnapshot = _ref.handleSnapshot,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React.createElement("button", {
    className: "snapshot-btn",
    onClick: handleSnapshot,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(MdAddAPhoto, {
    className: "snapshot-btn__icon"
  }), /*#__PURE__*/React.createElement("span", null, "Add to Class"));
};

export default SnapShotButton;